import { render, staticRenderFns } from "./BaseUserList.vue?vue&type=template&id=4ccc45fe&scoped=true"
import script from "./BaseUserList.vue?vue&type=script&lang=js"
export * from "./BaseUserList.vue?vue&type=script&lang=js"
import style0 from "./BaseUserList.vue?vue&type=style&index=0&id=4ccc45fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccc45fe",
  null
  
)

export default component.exports